import { createTheme } from '@mui/material/styles';
import "@fontsource/ubuntu/300.css";
import "@fontsource/ubuntu/400.css";
import "@fontsource/ubuntu/500.css";
import "@fontsource/ubuntu/700.css";
import { PRIMARY_COLOR, TERTIARY_COLOR } from 'utils';

const primaryButtonStyles = {
  color: TERTIARY_COLOR,
  backgroundColor: PRIMARY_COLOR,
  border: "1px solid transparent",
};

const primaryButtonOutlinedStyles = {
  border: `1px solid ${PRIMARY_COLOR}`,
  boxShadow: "0px 1px 2px 0px #1018280D !important",
  color: PRIMARY_COLOR,
  backgroundColor: TERTIARY_COLOR,
};

const theme = createTheme({
  typography: {
    fontFamily: '"Ubuntu", san-seriff',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
            h1, h2, h3, h4, h5, h6, p {
              margin: 0;
            }
          `
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '0.5rem 1rem !important',
          textTransform: "none",
          fontWeight: "400 !important",
          transition: 'all .3s',
          fontSize: "15px",
          lineHeight: "20px",
        },
      },
      variants: [
        {
          props: { color: "primary" },
          style: {
            ...primaryButtonStyles,
            "&:hover": {
              ...primaryButtonOutlinedStyles
            },
          },
        },
        // {
        //   props: { color: "error" },
        //   style: {
        //     ...errorButtonStyles,
        //   },
        // },
        {
          props: { color: "primary", variant: "outlined" },
          style: {
            ...primaryButtonOutlinedStyles,
            "&:hover": {
              ...primaryButtonStyles
            }
          },
        },
      ],
    },
    MuiIconButton: {
      styleOverrides: {
        root: {


        },
      },
      variants: [
        {
          props: { color: "primary" },
          style: {
            color: 'white',
            backgroundColor: "#00ABC8",

            "&:hover": {
              backgroundColor: "#00A1CD",
            }
          }
        }
      ]
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&:before": {
            display: 'none'
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          padding: '0'
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '2rem !important'
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent !important',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          flexGrow: 1,
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: "14px"
        },
    },
  }
  },
  palette: {
    primary: {
      main: '#20294c',
    },
    secondary: {
      main: '#718096',
    },
  },
});

export default theme;
